export default (error: any): error is string => error && typeof error === 'string';
